<form [formGroup]="detailsForm">
    <div class="step-content">
        <div class="status-info" [ngStyle]="{'padding-bottom': isNotConfigured() ? '0' : '2rem' }" *ngIf="isEditMode()">
            <div>
                {{'admin.partNumbers.form.labels.status' | translate }}
                <span [ngClass]="isNotConfigured() ? 'status-notConfigured' : 'status-configured'">
                  {{'admin.partNumbers.table.columns.status.' + partNumber?.status | translate}}
              </span>
            </div>
            <div class="config-info" *ngIf="isNotConfigured()">
                {{'admin.partNumbers.form.labels.copyFrom' | translate }}
                <app-dropdown-autocomplete
                    formControlName="basePartNumber"
                    [formControl]="detailsForm.controls['basePartNumber']"
                    [showErrors]="showValidations"
                    [items]="allExistingPartNumbers"
                    valueField="id"
                    displayField="name"
                    [emptyText]="'admin.partNumbers.form.labels.selectPN' | translate"
                    (selectItem)="onSelectBasePn($event)">
                </app-dropdown-autocomplete>
            </div>
        </div>
        <div class="content">
            <div class="column">
                <app-input *ngIf="isEditMode()"
                           formControlName="id"
                           labelAlign="left"
                           [formControl]="detailsForm.controls['id']"
                           [showErrors]="showValidations"
                           [isDisabled]="true"
                           placeholder="{{'admin.partNumbers.form.placeholders.id' | translate }}"
                           label="{{'admin.partNumbers.form.labels.id' | translate }}">
                </app-input>
                <app-input formControlName="name"
                           labelAlign="left"
                           [formControl]="detailsForm.controls['name']"
                           [showErrors]="showValidations"
                           [isDisabled]="isDisabled()"
                           placeholder="{{'admin.partNumbers.form.placeholders.name' | translate }}"
                           label="{{'admin.partNumbers.form.labels.name' | translate }}">
                </app-input>
                <app-input formControlName="valueStream"
                           labelAlign="left"
                           [formControl]="detailsForm.controls['valueStream']"
                           [showErrors]="showValidations"
                           [isDisabled]="isDisabled()"
                           placeholder="{{'admin.partNumbers.form.placeholders.valueStream' | translate }}"
                           label="{{'admin.partNumbers.form.labels.valueStream' | translate }}">
                </app-input>
                <app-input formControlName="sapFamily"
                           labelAlign="left"
                           [formControl]="detailsForm.controls['sapFamily']"
                           [showErrors]="showValidations"
                           [isDisabled]="isDisabled()"
                           placeholder="{{'admin.partNumbers.form.placeholders.sapFamily' | translate }}"
                           label="{{'admin.partNumbers.form.labels.sapFamily' | translate }}">
                </app-input>
                <app-input formControlName="ecam"
                           labelAlign="left"
                           [formControl]="detailsForm.controls['ecam']"
                           [showErrors]="showValidations"
                           [isDisabled]="isDisabled()"
                           placeholder="{{'admin.partNumbers.form.placeholders.ecam' | translate }}"
                           label="{{'admin.partNumbers.form.labels.ecam' | translate }}">
                </app-input>
            </div>
            <div class="column">
                <app-input *ngIf="isEditMode()"
                           formControlName="idMMDM"
                           labelAlign="left"
                           [formControl]="detailsForm.controls['idMMDM']"
                           [isDisabled]="true"
                           placeholder="{{'admin.partNumbers.form.placeholders.idMMDM' | translate }}"
                           label="{{'admin.partNumbers.form.labels.idMMDM' | translate }}">
                </app-input>
                <app-input formControlName="type"
                           labelAlign="left"
                           [formControl]="detailsForm.controls['type']"
                           [showErrors]="showValidations"
                           [isDisabled]="isDisabled()"
                           placeholder="{{'admin.partNumbers.form.placeholders.type' | translate }}"
                           label="{{'admin.partNumbers.form.labels.type' | translate }}">
                </app-input>
                <app-input formControlName="sapGroup"
                           labelAlign="left"
                           [formControl]="detailsForm.controls['sapGroup']"
                           [showErrors]="showValidations"
                           [isDisabled]="isDisabled()"
                           placeholder="{{'admin.partNumbers.form.placeholders.sapGroup' | translate }}"
                           label="{{'admin.partNumbers.form.labels.sapGroup' | translate }}">
                </app-input>
                <app-input formControlName="ecamVersion"
                           labelAlign="left"
                           [formControl]="detailsForm.controls['ecamVersion']"
                           [showErrors]="showValidations"
                           [isDisabled]="isDisabled()"
                           placeholder="{{'admin.partNumbers.form.placeholders.ecamVersion' | translate }}"
                           label="{{'admin.partNumbers.form.labels.ecamVersion' | translate }}">
                </app-input>
                <app-input formControlName="bomStatus"
                           labelAlign="left"
                           [formControl]="detailsForm.controls['bomStatus']"
                           [showErrors]="showValidations"
                           [isDisabled]="isDisabled()"
                           placeholder="{{'admin.partNumbers.form.placeholders.bomStatus' | translate }}"
                           label="{{'admin.partNumbers.form.labels.bomStatus' | translate }}">
                </app-input>
            </div>
        </div>
        <div class="row">
            <app-textarea formControlName="description"
                       labelAlign="left"
                       [formControl]="detailsForm.controls['description']"
                       [showErrors]="showValidations"
                       [isDisabled]="isViewMode()"
                       placeholder="{{'admin.partNumbers.form.placeholders.description' | translate }}"
                       label="{{'admin.partNumbers.form.labels.description' | translate }}">
            </app-textarea>
            <p *ngIf="showRelatedPNs()"
               class="title">{{'admin.partNumbers.form.placeholders.relatedPNs' | translate}}</p>
            <app-listbox *ngIf="showRelatedPNs()"
                         [items]="relatedPNs"
                         [isMaterial]="false"
                         [emptyMessage]="'admin.partNumbers.form.placeholders.noRelatedPNs' | translate">
            </app-listbox>
        </div>
    </div>
</form>
